// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AddTool.css (create a new CSS file if needed) */
/* Modal background overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure the modal is on top of other content */
}

/* Modal content */
.modal-content {
  background-color: #fff; /* White background for the modal */
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Box shadow for a slight elevation effect */
  max-width: 400px; /* Adjust the maximum width as needed */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

  .modal-content div {
    margin-bottom: 4px;
  }`, "",{"version":3,"sources":["webpack://./src/tooldb/src/modal.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,gCAAgC;EACtE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,gDAAgD;AACjE;;AAEA,kBAAkB;AAClB;EACE,sBAAsB,EAAE,mCAAmC;EAC3D,aAAa;EACb,kBAAkB;EAClB,uCAAuC,EAAE,6CAA6C;EACtF,gBAAgB,EAAE,uCAAuC;EACzD,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;EAEE;IACE,kBAAkB;EACpB","sourcesContent":["/* AddTool.css (create a new CSS file if needed) */\n/* Modal background overlay */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000; /* Ensure the modal is on top of other content */\n}\n\n/* Modal content */\n.modal-content {\n  background-color: #fff; /* White background for the modal */\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Box shadow for a slight elevation effect */\n  max-width: 400px; /* Adjust the maximum width as needed */\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n  .modal-content div {\n    margin-bottom: 4px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
